export const ExperienciaTipoEnum = Object.freeze({
	INTERESSE: 'interesse',
	VINCULO: 'vinculo',
});

export default {
	ExperienciaTipoEnum,
}
